/**
 * The external dependencies.
 */
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import ButtonRound from '../../components/general/button-round';

export default styled(ButtonRound)`
	position: relative;
	border: 2px solid ${({color}) => color ? color : '#fff'};
	margin-left: 9px;

	&:before,
	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 50%;
		left: 50%;
		background: ${({color}) => color ? color : '#fff'};
		width: 50%;
		height: 2px;
	}

	&:before { transform: translate(-50%) rotate(-45deg); }
	&:after { transform: translate(-50%) rotate(45deg); }
`;



// WEBPACK FOOTER //
// ./src/components/task/close-button.js